import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useCallback } from "react";
import { useSelector } from "react-redux";
import { EditableAssetTitle } from "~/components/AssetModalV2/components/EditableAssetTitle";
import { validateAssetTitle } from "~/components/AssetModalV2/utils";
import { INFO_PANEL_TITLE } from "~/constants/testIDs";
import { centralizedClipAssetIdSelector, centralizedClipIdSelector, centralizedDisplayTitleSelector } from "~/store/centralizedClip/selectors";
import { useUpdateAssetTitle } from "~/swr-hooks/clips/useUpdateAssetTitle";
export const EditiableInfoPanelTitle = /*#__PURE__*/ memo(()=>{
    const clipId = useSelector(centralizedClipIdSelector);
    const assetId = useSelector(centralizedClipAssetIdSelector);
    const title = useSelector(centralizedDisplayTitleSelector);
    const { updateAssetTitle } = useUpdateAssetTitle();
    const onSubmit = useCallback((newTitle)=>{
        if (title !== newTitle) {
            updateAssetTitle(clipId, newTitle, assetId);
        }
    }, [
        assetId,
        clipId,
        title,
        updateAssetTitle
    ]);
    return /*#__PURE__*/ _jsx("div", {
        className: "flex",
        "data-testid": INFO_PANEL_TITLE,
        children: /*#__PURE__*/ _jsx(EditableAssetTitle, {
            defaultValue: title,
            onSubmit: onSubmit,
            validate: validateAssetTitle
        })
    });
});
EditiableInfoPanelTitle.displayName = "EditiableInfoPanelTitle";
